import { BodySingleSubstitutionPartsListParams } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodySingleSubstitutionPartsList/getBodySingleSubstitutionPartsListQuery.type';
import { getBodySingleSubstitutionPartsListQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodySingleSubstitutionPartsList/getBodySingleSubstitutionPartsListQueryFunction';
import { queryOptions } from '@tanstack/react-query';

const getBodySingleSubstitutionPartsListQueryOption = (
  params: BodySingleSubstitutionPartsListParams,
) =>
  queryOptions({
    queryKey: ['get_body_single_substitution_parts_list', params],
    queryFn: () => getBodySingleSubstitutionPartsListQueryFunction(params),
    enabled: params.enabled,
  });
export default getBodySingleSubstitutionPartsListQueryOption;
